import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import localStorageUtil from "../utility/localStorageUtil";
import { useState } from "react";
import { faEye, faEyeSlash, faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import PillButton from "components/button/Pills";
import Corporate from "../assets/farming.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "components/firebase/firebase";


export interface LoginProps {
  email: string;
  password: string;
}

const schema = yup
  .object({
    email: yup.string().required("Please enter your Username"),
    password: yup.string().required("Please enter your Password"),
  })
  .required();

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(schema),
  });

  // Example function to manually set errors
  const validateManually = () => {
    setError("email", {
      type: "manual",
      message: "",
    });

    setError("password", {
      type: "manual",
      message: "",
    });
  };

  const handleLogin = (data: LoginProps) => {
    signInWithEmailAndPassword(auth, data.email, data.password)
      .then(async (userCredential) => {
        if (userCredential?.user) {
          const id_token = (userCredential as unknown as { _tokenResponse: { idToken: string } })._tokenResponse.idToken;
          localStorageUtil.setLocalStorage("accessToken", id_token);
          if (localStorage.getItem("accessToken")) {
            navigate("/admin/dashboard");
          }
          console.log("User account");
        }
      })
      .catch((err) => {
        setErrorMessage("Login failed. Please check your credentials.");
        validateManually();
      });
  };

  const onSubmit = (
    data: LoginProps,
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    handleLogin(data);
  };

  return (
    <div className="flex min-h-screen bg-white dark:bg-slate-800">
      <div
        className="hidden lg:block w-1/2 bg-cover bg-center"
        style={{ backgroundImage: `url(${Corporate})` }}
      ></div>

      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white dark:bg-slate-800">
        <div className=" bg-white dark:bg-slate-800 w-[80%] sm:w-[400px] p-8  relative py-12 rounded ">
          <div className="flex flex-row items-center gap-4 text-center mb-6">
            <FontAwesomeIcon
              icon={faRightFromBracket}
              size="2x"
              className="mt-1 text-green-700"
            />
            <h2 className="text-2xl font-bold text-green-900 dark:text-white">
              Sign in to your account
            </h2>
          </div>

          <form
            onSubmit={(e) => handleSubmit((data) => onSubmit(data, e))(e)}
            className="space-y-6"
          >
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-900 dark:text-white"
              >
                Email address
              </label>

              <input
                id="email"
                placeholder="Enter your email"
                type="text"
                {...register("email")}
                className={`text-sm rounded-lg w-full p-2.5 
      bg-white dark:bg-gray-800 
      text-gray-900 dark:text-white 
      border 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      ${errors.email ? "border-red-500" : "border-gray-300 dark:border-gray-600"}
    `}
              />

              {errors.email && (
                <p className="text-sm text-red-600 dark:text-red-400 mt-1">
                  {errors.email.message}
                </p>
              )}
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-900 dark:text-white"
              >
                Password
              </label>

              <div className="relative">
                <input
                  id="password"
                  placeholder="Enter your Password"
                  type={showPassword ? "text" : "password"}
                  {...register("password")}
                  className={`text-sm rounded-lg w-full p-2.5 pr-10 
        bg-white dark:bg-gray-800 
        text-gray-900 dark:text-white 
        border 
        focus:outline-none focus:ring-2 focus:ring-blue-500
        ${errors.password
                      ? "border-red-500"
                      : "border-gray-300 dark:border-gray-600"
                    }
      `}
                />

                {/* Eye Toggle */}
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-300"
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>

              {errors.password && (
                <p className="text-sm text-red-600 dark:text-red-400 mt-1">
                  {errors.password.message}
                </p>
              )}
            </div>

            <div className="mt-3">
              {errorMessage && (
                <p className="text-sm text-red-600 bg-red-100 border border-red-600 rounded p-4">
                  {errorMessage}
                </p>
              )}
            </div>
            <PillButton
              type="submit"
              variant="secondary"
              size="xl"
              className="
w-full font-medium py-2 px-4 rounded-md

bg-[#F0B73F] text-black border border-gray-500
hover:bg-gray-500 hover:text-white

dark:bg-white dark:text-gray-900
dark:border-gray-600
dark:hover:bg-gray-700 dark:hover:text-white

transition duration-300 ease-in-out
"
            // onClick={() => navigate("/admin/dashboard")}
            >
              Sign in
            </PillButton>
          </form>
        </div>
      </div>
    </div>
  );
}
